import o from"./well-known-symbol.js";import t from"./iterators.js";var a=o,e=t,n=a("iterator"),y=Array.prototype,l=function(r){return r!==void 0&&(e.Array===r||y[n]===r)};export{l as default};
